import { Divider, Theme, styled } from '@material-ui/core';

export const SidebarDivider = styled(Divider)<Theme>(({ theme }) => ({
  backgroundColor: theme.config.appbarColors.borderColor,
  height: '0.7rem',
}));
